{
	"ariaSetPhotoCullingTag": "Set Photo Culling Tag",
	"auto": "Auto",
	"candidate": "Candidate",
	"reject": "Reject",
	"topPick": "Top Pick"
}
